import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthToken } from "./useAuthToken";
import { useCurrentUser } from "@/pages/auth/hooks/useAuth";

interface GuardProps {
  children?: ReactNode;
}

export function RequireAuth({ children }: Readonly<GuardProps>) {
  const { isAuthenticated } = useAuthToken();
  const location = useLocation();

  // Triggers /api/auth/me/ on refresh or initial protected page load
  useCurrentUser();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}

export default RequireAuth;
